import type { FC } from 'react'
import React from 'react'
import Redirect from '@/router/components/Redirect'
import { EFinancingOfferRoute } from '@/types'

const FinancingRedirect: FC = () => <Redirect url={EFinancingOfferRoute.main} />

export default FinancingRedirect
